import type { BrandConfig } from './types'

/** Triplo M's (TMS) brand configuration. */
export const triplomssBrand: BrandConfig = {
  name: 'Triploms',
  hostname: 'app.triploms.com',

  logoUrl: '/brands/tms/logo.png',
  faviconUrl: '/brands/tms/favicon.png',
  title: 'TMS',

  googleFontsUrl: '',

  colors: {
    light: {
      text: '#000000',
      textH: '#000000',
      bg: '#f6f8fb',
      border: '#d7dce3',
      codeBg: '#f6f8fb',
      accent: '#0270C0',
      accentBg: 'rgba(2, 112, 192, 0.10)',
      accentBorder: 'rgba(2, 112, 192, 0.24)',
      socialBg: '#f6f8fb',
      shadow: 'rgba(0, 0, 0, 0.08)',
    },
    dark: {
      text: '#000000',
      textH: '#000000',
      bg: '#f6f8fb',
      border: '#d7dce3',
      codeBg: '#f6f8fb',
      accent: '#0270C0',
      accentBg: 'rgba(2, 112, 192, 0.10)',
      accentBorder: 'rgba(2, 112, 192, 0.24)',
      socialBg: '#f6f8fb',
      shadow: 'rgba(0, 0, 0, 0.08)',
    },
  },

  fonts: {
    sans: 'Arial, Helvetica, sans-serif',
    heading: 'Arial, Helvetica, sans-serif',
    mono: 'ui-monospace, Consolas, monospace',
  },
}
